module.exports = __webpack_public_path__ + "img/bus_01.e2a5e9b0.jpg";